"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _translations = require("@insided/deprecated-libs/translationsUtils/translations");

var _preactCompat = require("preact-compat");

var _classnames = _interopRequireDefault(require("classnames"));

var _TagPill = _interopRequireDefault(require("./TagPill"));

var _message = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/message"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _Button2 = _interopRequireDefault(require("@insided/deprecated-control/ui-components/Button"));

var _LikeFeedback = _interopRequireDefault(require("@insided/shared/icons/LikeFeedback"));

var _Dislike = _interopRequireDefault(require("@insided/shared/icons/Dislike"));

var _Close = _interopRequireDefault(require("@insided/shared/icons/Close"));

var _Warning = _interopRequireDefault(require("@insided/destination/icons/Warning"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var FeedbackState;

(function (FeedbackState) {
  FeedbackState[FeedbackState["INITIAL"] = 0] = "INITIAL";
  FeedbackState[FeedbackState["DISLIKE_IN_PROGRESS"] = 1] = "DISLIKE_IN_PROGRESS";
  FeedbackState[FeedbackState["FINAL"] = 2] = "FINAL";
  FeedbackState[FeedbackState["HIDDEN"] = 3] = "HIDDEN";
})(FeedbackState || (FeedbackState = {}));

var FINAL_STATE_TIMEOUT = 5000;

var FeedbackUI = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(FeedbackUI, _PureComponent);

  var _super = _createSuper(FeedbackUI);

  function FeedbackUI() {
    var _this;

    (0, _classCallCheck2.default)(this, FeedbackUI);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      feedbackState: FeedbackState.INITIAL,
      selectedOptions: {},
      additionalInfo: '',
      inputTouched: false,
      showError: false,
      isSaveLoading: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onYesClick", function () {
      var _this$props$onLike, _this$props;

      (_this$props$onLike = (_this$props = _this.props).onLike) === null || _this$props$onLike === void 0 ? void 0 : _this$props$onLike.call(_this$props).then(function () {
        return _this.onFeedbackSuccess();
      }).catch(function () {
        return _this.onFeedbackError();
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onNoClick", function () {
      _this.setState({
        feedbackState: FeedbackState.DISLIKE_IN_PROGRESS
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onFeedbackSuccess", function () {
      _this.setState({
        feedbackState: FeedbackState.FINAL,
        isSaveLoading: false
      });

      setTimeout(function () {
        var _this$props$onDismiss, _this$props2;

        _this.setState({
          feedbackState: FeedbackState.HIDDEN
        });

        (_this$props$onDismiss = (_this$props2 = _this.props).onDismiss) === null || _this$props$onDismiss === void 0 ? void 0 : _this$props$onDismiss.call(_this$props2);
      }, FINAL_STATE_TIMEOUT);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onFeedbackError", function () {
      _this.setState({
        showError: true,
        isSaveLoading: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updateOption", function (optionId, checked) {
      _this.setState(function (state) {
        return {
          selectedOptions: _objectSpread(_objectSpread({}, state.selectedOptions), {}, (0, _defineProperty2.default)({}, optionId, checked))
        };
      });
    });
    return _this;
  }

  (0, _createClass2.default)(FeedbackUI, [{
    key: "saveFeedback",
    value: function saveFeedback() {
      var _this$props$onDislike,
          _this$props3,
          _this2 = this;

      var additionalInfo = this.state.additionalInfo;
      this.setState({
        isSaveLoading: true
      });
      var selectedOptions = this.getSelectedIds();
      (_this$props$onDislike = (_this$props3 = this.props).onDislike) === null || _this$props$onDislike === void 0 ? void 0 : _this$props$onDislike.call(_this$props3, selectedOptions, additionalInfo).then(function () {
        return _this2.onFeedbackSuccess();
      }).catch(function () {
        return _this2.onFeedbackError();
      });
    }
  }, {
    key: "closePanel",
    value: function closePanel() {
      this.setState({
        feedbackState: FeedbackState.INITIAL
      });
    }
  }, {
    key: "getSelectedIds",
    value: function getSelectedIds() {
      var _this3 = this;

      return Object.keys(this.state.selectedOptions).filter(function (key) {
        return _this3.state.selectedOptions[key];
      });
    }
  }, {
    key: "shouldDisableSend",
    value: function shouldDisableSend() {
      if (this.state.selectedOptions.other) {
        return !this.state.additionalInfo;
      }

      return this.getSelectedIds().length === 0;
    }
  }, {
    key: "getPhrases",
    value: function getPhrases() {
      if (this.props.isControl) {
        return {
          is_this_helpful: 'Is this helpful?',
          thank_you_for_your_feedback: 'Thank you for your feedback!',
          tell_us_more: 'Please tell us more',
          other: 'Other',
          provide_additional_feedback: 'Kindly provide additional feedback',
          optional_provide_additional_feedback: '(Optional) Feel free to provide additional feedback',
          field_required: 'This field is required for the selected option.',
          send: 'Send',
          save_failed_error: 'Something went wrong. We failed to save the feedback. Please try again.'
        };
      }

      return {
        is_this_helpful: (0, _preact.h)(_phrase.default, {
          p: "hub_ai.feedback.is_this_helpful"
        }),
        thank_you_for_your_feedback: (0, _preact.h)(_phrase.default, {
          p: "hub_ai.feedback.thank_you_for_your_feedback"
        }),
        tell_us_more: (0, _preact.h)(_phrase.default, {
          p: "hub_ai.feedback.tell_us_more"
        }),
        other: (0, _preact.h)(_phrase.default, {
          p: "hub_ai.feedback.other"
        }),
        provide_additional_feedback: (0, _translations.t)('Forum', 'hub_ai.feedback.provide_additional_feedback'),
        optional_provide_additional_feedback: (0, _translations.t)('Forum', 'hub_ai.feedback.optional_provide_additional_feedback'),
        field_required: (0, _preact.h)(_phrase.default, {
          p: "hub_ai.feedback.field_required"
        }),
        send: (0, _preact.h)(_phrase.default, {
          p: "hub_ai.feedback.send"
        }),
        save_failed_error: (0, _preact.h)(_phrase.default, {
          p: "hub_ai.feedback.save_failed_error"
        })
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$state = this.state,
          feedbackState = _this$state.feedbackState,
          selectedOptions = _this$state.selectedOptions,
          inputTouched = _this$state.inputTouched,
          showError = _this$state.showError,
          isSaveLoading = _this$state.isSaveLoading;
      var _this$props4 = this.props,
          options = _this$props4.options,
          isControl = _this$props4.isControl;
      var additionalInfoRequired = this.state.selectedOptions.other;
      var showValidationError = additionalInfoRequired && !this.state.additionalInfo && inputTouched;
      var phrases = this.getPhrases();
      return (0, _preact.h)("div", {
        className: (0, _classnames.default)('feedback', {
          control: isControl
        }),
        "data-bounded-context": "HubAI",
        "data-entity": "Feedback UI"
      }, (feedbackState === FeedbackState.INITIAL || feedbackState === FeedbackState.DISLIKE_IN_PROGRESS) && (0, _preact.h)("div", {
        className: "feedback--initial"
      }, (0, _preact.h)("div", {
        className: "feedback--text"
      }, phrases.is_this_helpful), (0, _preact.h)("div", {
        className: "feedback--buttons"
      }, (0, _preact.h)("button", {
        onClick: this.onYesClick,
        className: "feedback--button feedback--button__like",
        "data-track-type": "click",
        "data-element-name": "Like button"
      }, (0, _preact.h)(_LikeFeedback.default, {
        width: 16,
        height: 16
      })), (0, _preact.h)("button", {
        onClick: this.onNoClick,
        className: (0, _classnames.default)('feedback--button feedback--button__dislike', {
          selected: feedbackState === FeedbackState.DISLIKE_IN_PROGRESS
        }),
        "data-track-type": "click",
        "data-element-name": "Dislike button"
      }, (0, _preact.h)(_Dislike.default, {
        width: 16,
        height: 16
      })))), feedbackState === FeedbackState.FINAL && (0, _preact.h)("div", {
        className: "feedback--text feedback--final"
      }, phrases.thank_you_for_your_feedback), feedbackState === FeedbackState.DISLIKE_IN_PROGRESS && (0, _preact.h)("div", {
        className: "feedback--panel"
      }, (0, _preact.h)("div", {
        className: "feedback--panel__header"
      }, (0, _preact.h)("div", {
        className: "feedback--text"
      }, phrases.tell_us_more), (0, _preact.h)("button", {
        className: "feedback--panel__header-close",
        onClick: function onClick() {
          return _this4.closePanel();
        },
        "data-track-type": "click",
        "data-element-name": "Close button"
      }, (0, _preact.h)(_Close.default, {
        width: 24,
        height: 24
      }))), (0, _preact.h)("div", {
        className: "feedback--options"
      }, options.map(function (option) {
        return (0, _preact.h)(_TagPill.default, {
          key: option,
          customClass: "feedback--option",
          active: selectedOptions[option],
          onUpdate: function onUpdate(value) {
            return _this4.updateOption(option, value);
          },
          label: option
        });
      }), (0, _preact.h)(_TagPill.default, {
        key: "other",
        customClass: "feedback--option",
        active: selectedOptions.other,
        onUpdate: function onUpdate(value) {
          return _this4.updateOption('other', value);
        },
        label: phrases.other
      })), (0, _preact.h)("div", {
        className: "feedback--footer"
      }, (0, _preact.h)("div", {
        className: "feedback--footer__input"
      }, (0, _preact.h)("input", {
        type: "text",
        className: (0, _classnames.default)({
          error: showValidationError
        }),
        placeholder: additionalInfoRequired ? phrases.provide_additional_feedback : phrases.optional_provide_additional_feedback,
        onInput: function onInput(e) {
          var _e$target;

          var value = (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value;

          _this4.setState({
            additionalInfo: value,
            inputTouched: !value
          });
        },
        onBlur: function onBlur() {
          return _this4.setState({
            inputTouched: true
          });
        }
      }), showValidationError && (0, _preact.h)("div", {
        className: "error-msg"
      }, (0, _preact.h)(_Warning.default, {
        width: 12,
        height: 12
      }), (0, _preact.h)("div", {
        className: "tex"
      }, phrases.field_required))), isControl ? (0, _preact.h)(_Button.default, {
        variant: "primary",
        size: "medium",
        className: "feedback--footer__button",
        onClick: function onClick() {
          return _this4.saveFeedback();
        },
        disabled: this.shouldDisableSend(),
        isLoading: isSaveLoading,
        "data-track-type": "click",
        "data-element-name": "Save button"
      }, phrases.send) : (0, _preact.h)(_Button2.default, {
        primary: true,
        medium: true,
        className: "feedback--footer__button",
        onClick: function onClick() {
          return _this4.saveFeedback();
        },
        disabled: this.shouldDisableSend(),
        loading: isSaveLoading,
        "data-track-type": "click",
        "data-element-name": "Save button"
      }, phrases.send))), showError && (0, _preact.h)(_message.default, {
        isControl: true,
        variant: "error",
        onDismiss: function onDismiss() {
          _this4.setState({
            showError: false
          });
        },
        timer: 3000
      }, phrases.save_failed_error));
    }
  }]);
  return FeedbackUI;
}(_preactCompat.PureComponent);

exports.default = FeedbackUI;